import * as yup from "yup";
import { MSG } from "../constants/MSG";

//eslint-disable-next-line
const newPasswordrgx =
	"^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$";

export const changePasswordSchema = yup.object().shape({
	oldPassword: yup.string().trim().required(MSG.REQUIRED_OLD_PASSWORD),
	newPassword: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_NEW_PASSWORD)
		.matches(newPasswordrgx, MSG.REQUIRED_VALID_PASSWORD),
	confirmPassword: yup
		.string()
		.trim()
		.oneOf([yup.ref("newPassword"), null], MSG.PASSWORDS_DO_NOT_MATCH)
		.required(MSG.REQUIRED_CONFIRM_PASSWORD),
});

export const profileupdateSchema = yup.object().shape({
	firstName: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_FIRST_NAME)
		.max(15, MSG.REQUIRED_VALID_FIRSTNAME),

	lastName: yup
		.string()
		.trim()
		.required(MSG.REQUIRED_LAST_NAME)
		.max(15, MSG.REQUIRED_VALID_LASTNAME),
	// .matches(/^[aA-zZ\s]+$/, MSG.REQUIRED_ONLY_LATTIN_LETTERS),
});

// const phoneRegExp =
// 	/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const mobileSchema = yup.object().shape({
	phone: yup
		.string()
		.trim()
		.required(MSG.PROVIDE_MOBILE_NUMBER)
		.matches(
			new RegExp(/^\(?([0-9]{0,3})\)?[-. ]?([0-9]{0,3})[-. ]?([0-9]{10,10})$/),
			MSG.REQUIRED_PROPER_MOBILE_NUMBER
		),
});
